import { connect } from 'react-redux'
import ErrorOverlay from '../components/ErrorOverlayView'
import {resetError} from "../modules/error";

const mapDispatchToProps = {
  resetError: resetError
};

const mapStateToProps = (state) => ({
  showErrorPopup: state.error.display,
  type: state.error.type
});


export default connect(mapStateToProps, mapDispatchToProps)(ErrorOverlay)


// WEBPACK FOOTER //
// ./src/components/shared/ErrorOverlay/containers/ErrorOverlayContainer.js